<div fxLayout="row" fxLayoutGap="50px"  fxFlexFill>
    
    <mat-form-field fxFlex="170px" fxFlexOffset="20px">
        <input [(ngModel)]="reembolso.data"
               matInput 
               #campoDataReembolso
               name="dataReembolso_{{pinDataReembolso}}"
               [required]="reembolso.contaBancaria.id"
               [matDatepicker]="dataReembolso"
               placeholder="Data do reembolso" 
               (change)="onCarregarContasReembolso()"              
               >
        <mat-datepicker-toggle matSuffix [for]="dataReembolso"></mat-datepicker-toggle>
        <mat-datepicker #dataReembolso></mat-datepicker>
    </mat-form-field>

    <!-- VALOR -->
    <mat-form-field fxFlex="170px" fxFlexOffset="20px">
        <input [(ngModel)]=reembolso.valor 
               currencyMask 
               name="valorReembolso_{{pinValorReembolso}}"
               placeholder="Valor do reembolso"
               required
               matInput 
               maxlength="13"
               [options]="{ prefix: '', thousands: '.', decimal: ',' }" />
        <span matPrefix *ngIf="!reembolso.statusPercentual">R$&nbsp;</span>
        <span matSuffix *ngIf="reembolso.statusPercentual" style="padding-left: 5px;">%&nbsp;</span>
    </mat-form-field>

    <mat-form-field fxFlex= "170px" fxFlexOffset="20px">
        <input [(ngModel)]="reembolso.transacao"
               #descricao
               name="transacao_{{pinTransacao}}"
               placeholder="Nr. Transação"
               matInput maxlength="20"
               />
<!--        <mat-hint align="start">{{descricao.value.length}} / 200</mat-hint>    -->
    </mat-form-field>



    <div fxFlex="10%" style="margin-top: 22px; margin-left: 20px;" >
 <!--
        <mat-checkbox color="primary"
                      title="Escolha a forma de reembolso entre % ou R$" 
                      name="checkReembolso_{{pinCheckReembolso}}" 
                      [(ngModel)]="reembolso.statusPercentual">
            (%)
        </mat-checkbox>
-->    
        <button mat-icon-button 
                *ngIf="perfilAcesso.deleta" 
                (click)="deletar()"
                style="padding: 0px;">
            <mat-icon>delete_forever</mat-icon>
        </button>                                
    </div>    
 
</div>


<div fxLayout="row" fxLayoutGap="50px">

    <mat-form-field fxFlex="50" fxFlexOffset="20px">
        <mat-label>Conta reembolso</mat-label>
        <mat-select [(ngModel)]=reembolso.contaBancaria.id
                    (selectionChange)="validarContaReembolso()" 
                    required
                    name="contasReembolso_{{pinContaBancaria}}">
            <mat-option></mat-option>
            <mat-option *ngFor="let i of contasCentroCusto" [value]=i.id>
                {{getNomeProjetoPrograma(i)}}
            </mat-option>
        </mat-select>
        <mat-hint *ngIf="contasCentroCusto?.length === 0" align="start">Nenhuma conta bancária cadastrada</mat-hint>
    </mat-form-field>

    <mat-form-field fxFlex="50" fxFlexOffset="20px">
        <mat-label>Conta de destino do reembolso</mat-label>
        <mat-select [(ngModel)]=reembolso.contaBancariaDestino.id
                    (selectionChange)="carregarContaBancariaDestino()" 
                    required
                    name="contasDestino_{{pinContaBancaria}}">
            <mat-option></mat-option>
            <mat-option *ngFor="let i of contasCentroCusto" [value]=i.id>
                {{getNomeProjetoPrograma(i)}}
            </mat-option>
        </mat-select>
        <mat-hint *ngIf="contasCentroCusto?.length === 0" align="start">Nenhuma conta bancária cadastrada</mat-hint>
    </mat-form-field>
</div>

<div fxLayout="row" fxLayoutGap="50px">
    <mat-form-field fxFlex= "100%" fxFlexOffset="20px">
        <input [(ngModel)]="reembolso.descricao"
               #descricao
               name="descricao_{{pinDescricao}}"
               placeholder="Descrição"
               matInput maxlength="200"
               />
        <mat-hint align="start">{{descricao.value.length}} / 200</mat-hint>       
    </mat-form-field>
</div>
